import { type ReactNode } from 'react';
import { cn } from '../../lib/cn';

// Разделитель посреди ленты сообщений: пилюля по центру.
//
// Обобщение дневного разделителя («сегодня», «3 сентября»), который жил внутри страницы
// диалогов. Второй повод для такой же пилюли - смена канала: «Гость перешёл в MAX · бот
// Smena». Два разных элемента для одного визуального приёма разъехались бы при первой же
// правке отступов, поэтому форма одна, а содержимое передаётся детьми.

export function ThreadSeparator({ children, className }: { children: ReactNode; className?: string }) {
  return (
    <div className={cn('my-3 flex justify-center', className)}>
      <span className="inline-flex items-center gap-1.5 rounded-full border border-line bg-panel px-3 py-0.5 text-[11px] font-semibold text-muted">
        {children}
      </span>
    </div>
  );
}
